<template>
    <section class="breaking-news-landing  style-section ">
        <h2 class="seo-only">
            خبرهای علی‌بابا
        </h2>
        <div class="container">
            <div class="owl-carousel carousel-alibaba-style owl-carousel-breaking-news">
                <a :href="appAdjustLink" class="item">
                    <div @click="sendApplicationEvent('App Promotion')" class="breaking-news-landing__item">
                        <div class="item__bg-news" :style="$bgImage('breaking-news/app-promotion.jpg', 580, 220, 100)" />
                    </div>
                </a>
                <nuxt-link to="/visa/canada" class="item" no-prefetch>
                    <div @click="sendApplicationEvent('Canada Visa')" class="breaking-news-landing__item">
                        <div class="item__bg-news" :style="$bgImage('breaking-news/canada-visa.jpg', 580, 220, 100)" />
                    </div>
                </nuxt-link>
                <nuxt-link to="/airlines/lufthansa" class="item" no-prefetch>
                    <div @click="sendApplicationEvent('Lufthansa')" class="breaking-news-landing__item">
                        <div class="item__bg-news" :style="$bgImage('breaking-news/lufthansa-airlines.jpg', 580, 220, 100)" />
                    </div>
                </nuxt-link>
                <nuxt-link to="/airlines/austrian" class="item" no-prefetch>
                    <div @click="sendApplicationEvent('Austrian')" class="breaking-news-landing__item">
                        <div class="item__bg-news" :style="$bgImage('breaking-news/austrian-airlines.jpg', 580, 220, 100)" />
                    </div>
                </nuxt-link>
                <a href="https://jabama.com/" class="item" target="_blank" rel="nofollow noopener noreferrer">
                    <div @click="sendApplicationEvent('Jabama')" class="breaking-news-landing__item">
                        <div class="item__bg-news" :style="$bgImage('breaking-news/jabama-domestic.jpg', 580, 220, 100)" />
                    </div>
                </a>
                <nuxt-link to="/hotel" class="item" no-prefetch>
                    <div @click="sendApplicationEvent('Hotel')" class="breaking-news-landing__item">
                        <div class="item__bg-news" :style="$bgImage('breaking-news/hotel-domestic.jpg', 580, 220, 100)" />
                    </div>
                </nuxt-link>
                <nuxt-link to="/charter-ticket" class="item" no-prefetch>
                    <div @click="sendApplicationEvent('Charter Ticket')" class="breaking-news-landing__item">
                        <div class="item__bg-news" :style="$bgImage('breaking-news/charter.jpg', 580, 220, 100)" />
                    </div>
                </nuxt-link>
                <!-- <nuxt-link to="/bonrail" class="item">
                    <div @click="sendApplicationEvent('Bonrail')" class="breaking-news-landing__item">
                        <div class="item__bg-news" :style="$bgImage('breaking-news/bonrail.jpg', 580, 220, 100)" />
                    </div>
                </nuxt-link> -->
            </div>
        </div>
    </section>
</template>

<script>

export default {
    data () {
        return {
            appAdjustLink: 'https://app.adjust.com/a40yjvf?engagement_type=fallback_click&redirect=https%3A%2F%2Fwww.alibaba.ir%2Fapp%3Fnotracker%3Dtrue%26utm_source%3Dalibaba_website_card_view%26utm_medium%3Dwebsite%26utm_campaign%3Donsite-promotion-q4',
        };
    },
    mounted () {
        this.initOwl();
    },
    methods: {
        initOwl () {
            require('owl.carousel');

            const owlJournal = $('.owl-carousel-journal');
            const owlBreakingNews = $('.owl-carousel-breaking-news');
            const owlCarouselAirline = $('.owl-carousel-airline');

            // Carousel Journal
            owlJournal.owlCarousel({
                rtl: true,
                loop: true,
                margin: 10,
                nav: false,
                center: false,
                items: 4,
                autoplay: true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 2,
                    },
                    992: {
                        items: 4,
                    },
                },
            });

            // Carousel Breaking News
            owlBreakingNews.owlCarousel({
                rtl: true,
                loop: true,
                margin: 10,
                nav: false,
                center: false,
                items: 1,
                autoplay: true,
                autoplayTimeout: 5000,
                responsive: {
                    0: {
                        loop: true,
                        item: 1,
                        autoplayTimeout: 5000,
                    },
                    768: {
                        items: 2,
                    },
                },
            });

            // Carousel Airline
            owlCarouselAirline.owlCarousel({
                rtl: true,
                loop: true,
                margin: 10,
                nav: false,
                center: false,
                items: 10,
                autoplay: true,
                autoplayTimeout: 5000,
                autoplayHoverPause: false,
                responsive: {
                    0: {
                        items: 4,
                    },
                    768: {
                        items: 6,
                    },
                    1200: {
                        items: 10,
                    },
                },
            });
        },
        sendApplicationEvent (label) {
            this.$gtm.sendGTMEvent({
                event: 'event',
                eventCategory: 'UX',
                eventAction: 'Home Page Banners',
                eventLabel: label,
            });
        },
    },
};

</script>

<style lang="scss">
    @import '~vars';

    .owl-carousel-breaking-news {

        .item {
            width: 100%;
            border-radius: 5px;
        }
    }

    .breaking-news-landing {
        @media (min-width: 768px) and (max-width: 1250px) {
            padding-top: 5px;
            padding-bottom: 5px;

            .owl-dots {
                margin-bottom: 0;
            }
        }
        @media (min-width: 300px) and (max-width: 767px) {
            padding-bottom: 10px;

            .owl-dots {
                margin-bottom: 10px;
            }
        }
        background-color: $snow-white;

        .item__bg-news {
            height: 220px;
            background-size: cover;
            background-position: 100%;
            border-radius: 3px;
            @media (min-width: 768px) and (max-width: 993px) {
                height: 135px;
            }
            @media (min-width: 994px) and (max-width: 1100px) {
                height: 180px;
            }
        }
    }

    body.mobile {

        .breaking-news-landing {
            background-color: white;
            padding: 20px 0 5px;

            .item__bg-news {
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center center;
            }
            @media (min-width: 300px) and (max-width: 480px) {

                .item__bg-news {
                    height: 135px;
                }
            }
        }
    }
</style>
